// Firebase dummy implementation - using Supabase instead
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, Auth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";

// Dummy config to prevent initialization errors
const firebaseConfig = {
  apiKey: "dummy",
  authDomain: "dummy.firebaseapp.com",
  projectId: "dummy",
  storageBucket: "dummy.appspot.com",
  messagingSenderId: "123456",
  appId: "1:123456:web:dummy"
};

const app = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db: Firestore = getFirestore(app);

// Disable actual Firebase operations
console.warn("Firebase initialized with dummy config - using Supabase for actual operations");
